// extracted by mini-css-extract-plugin
module.exports = {"hero":"styles_hero__1fqOw","content":"styles_content__2YeVn","image":"styles_image__3jdai"};